"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
// import { PaymentMethod } from '@l2p/pay-api'
var useOrderAndSplitPaymentMethodsByGEO = function (paymentSettings) {
    var _a, _b;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var splitMethods = (0, react_1.useCallback)(function (methods) {
        if (!methods)
            return [];
        var splitMethods = [];
        methods.forEach(function (method) {
            var _a, _b, _c, _d, _e;
            var splitConfig = paymentSettings.splittedMethods;
            if ((method === null || method === void 0 ? void 0 : method.name) &&
                ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode) &&
                ((_c = splitConfig === null || splitConfig === void 0 ? void 0 : splitConfig[String((_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode)]) === null || _c === void 0 ? void 0 : _c[method === null || method === void 0 ? void 0 : method.name])) {
                var splitMethodConfig = (_e = splitConfig === null || splitConfig === void 0 ? void 0 : splitConfig[String((_d = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _d === void 0 ? void 0 : _d.countryCode)]) === null || _e === void 0 ? void 0 : _e[method === null || method === void 0 ? void 0 : method.name];
                splitMethodConfig.forEach(function (item) {
                    var newMethod = __assign(__assign({}, method), { childMethodId: item });
                    splitMethods.push(newMethod);
                });
            }
            else
                splitMethods.push(method);
        });
        return splitMethods;
    }, [paymentSettings, (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode]);
    return (0, react_1.useCallback)(function (methods) {
        var splitedMethods = splitMethods(methods);
        var methodsWithSettings = [];
        var methodsWithoutSettings = [];
        splitedMethods.forEach(function (method) {
            var _a;
            var methodId = method['childMethodId']
                ? method['childMethodId']
                : method.name;
            var methodConfig = (_a = paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.methods) === null || _a === void 0 ? void 0 : _a[String(methodId)];
            if (methodConfig && methodConfig['order'])
                methodsWithSettings.push(__assign(__assign({}, method), { settings: methodConfig }));
            else
                methodsWithoutSettings.push(method);
        });
        var orderedMethods = methodsWithSettings.sort(function (a, b) {
            var _a, _b, _c, _d, _e, _f;
            return ((((_b = (_a = a === null || a === void 0 ? void 0 : a['settings']) === null || _a === void 0 ? void 0 : _a['order']) === null || _b === void 0 ? void 0 : _b[String((_c = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _c === void 0 ? void 0 : _c.countryCode)]) || 1000000) -
                (((_e = (_d = b === null || b === void 0 ? void 0 : b['settings']) === null || _d === void 0 ? void 0 : _d['order']) === null || _e === void 0 ? void 0 : _e[String((_f = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _f === void 0 ? void 0 : _f.countryCode)]) || 1000000));
        });
        return {
            withSetup: orderedMethods,
            additional: methodsWithoutSettings,
        };
    }, [paymentSettings, (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode, splitMethods]);
};
exports.default = useOrderAndSplitPaymentMethodsByGEO;
